"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.166 7.634c.144-.579.98-.579 1.124 0l.049.197c.666 2.675 2.658 4.839 5.297 5.756a.541.541 0 0 1 0 1.026c-2.64.917-4.631 3.081-5.297 5.756l-.05.197c-.144.579-.98.579-1.123 0l-.05-.197C8.45 17.694 6.46 15.53 3.82 14.613a.541.541 0 0 1 0-1.026c2.64-.917 4.631-3.081 5.298-5.756zm7.221-4.37c.088-.352.596-.352.684 0l.03.12a5 5 0 0 0 3.225 3.504.33.33 0 0 1 0 .624 5 5 0 0 0-3.225 3.504l-.03.12c-.088.352-.596.352-.684 0l-.03-.12a5 5 0 0 0-3.224-3.504.33.33 0 0 1 0-.624 5 5 0 0 0 3.224-3.504z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AISparkleIcon24.js.map